// Imagen por defecto para proyectos sin backgroundImage: persona viendo proyectos
// inmobiliarios en el celular (foto, mismo tratamiento apagado que las fotos de proyecto).
import DefaultHeroPic from '../../../assets/plr_default_hero.webp';

type HeroOptions = {
  backgroundImage?: string;
  hideHero?: boolean;
  heroQuery?: string | null;
  partnerName?: string;
};

export const PLR_HERO_FALLBACK_IMAGE = DefaultHeroPic;
export const PLR_RESULT_TIME = 'Resultado en cerca de 3 minutos';
export const PLR_ALLIANCE_COPY = 'Evaluación en alianza con banca.me';

export const resolvePlrHeroImage = (backgroundImage?: string) => (
  backgroundImage || PLR_HERO_FALLBACK_IMAGE
);

// La entidad por defecto de cada partner se crea como "<Partner>-default": es un nombre interno,
// no un proyecto, así que en su lugar se muestra el nombre del partner (sin sobrelínea).
const INTERNAL_DEFAULT_ENTITY = /-\s*default$/i;

// Hay un proyecto con nombre (no la entidad "-default" ni sin entidad): los textos pueden decir
// "este proyecto".
export const hasProjectName = (entityName?: string) => {
  const entity = entityName?.trim();
  return Boolean(entity) && !INTERNAL_DEFAULT_ENTITY.test(entity as string);
};

export const projectEntityLabel = (entityName?: string, partnerName?: string) => (
  hasProjectName(entityName) ? (entityName as string).trim() : partnerName?.trim() || ''
);

export const companyOverline = (entityName?: string, partnerName?: string) => {
  const company = partnerName?.trim();
  if (!company || company === projectEntityLabel(entityName, partnerName)) return undefined;
  return company;
};

const shouldShowPlrHero = (options: HeroOptions): boolean => {
  if (options.hideHero) return false;
  if (options.heroQuery === '0' || options.heroQuery === 'false') return false;
  const name = options.partnerName?.toLowerCase();
  if (name === 'banca.me') return false;
  return true;
};

export default shouldShowPlrHero;
